import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import dynamicfunction from '../../utils/dynamicfunction';
import { changeLanguage, changePassword, getLanguages } from '../../store/actions/settingAction';
import { useEffect, useState } from 'react';
import { getContentKeyAccToLang, showToast } from '../../utils/utils';
import { setFetchedClient } from '../../store/slices/investmentsSlice';
import { kyc_update_link, kyc_update_link_client_classification } from '../../config/config';
import { initiateKyc } from '../../store/actions/corporateAction';
import {
  setClientApplicantId,
  setClientApplicationId,
  setCompanyId,
  setRejectionMsg,
  setIsKyc,
  setApplicantType,
  setKsaCorporate,
} from '../../store/slices/constantSlice';
import { createKycApplication } from '../../store/actions/individualAction';
import { getUserDetail, selectAccounts } from '../../store/actions/authActions';
import { setUserData } from '../../store/slices/commonSlice';
import { getClientData } from '../../store/actions/investmentsAction';

export default () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [confirmModal, setConfirmModal] = useState(false);
  const [switchAccountData, setSwitchAccountData] = useState(null);
  const { TextWeight, isArabic, direction } = dynamicfunction();

  const { settingContent } = useSelector((state) => state.content);
  const { settingLoading, languages, passwordLoading } = useSelector((state) => state.setting);
  const { user } = useSelector((state) => state.common);
  const { clientDetails } = useSelector((state) => state.investments);
  const { kyc_loading } = useSelector((state) => state.corporate);

  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const type =
    Number(user?.applicantTypeId) === 12
      ? 'KSA Resident'
      : Number(user?.applicantTypeId) === 11
        ? 'KSA National'
        : Number(user?.applicantTypeId) === 13
          ? 'GCC National'
          : 'Other National';

  useEffect(() => {
    dispatch(
      getLanguages((val) => {
        setSelectedLanguage(val?.result?.find((item) => item?.id === user?.clientLanguage?.languageId));
      }),
    );
  }, []);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(settingContent?.web_general_setting?.data?.attributes, key, isArabic);
  };

  const onLanguageSelect = (val) => setSelectedLanguage(val);

  const handleSubmitLanguage = () => {
    if (selectedLanguage) {
      dispatch(
        changeLanguage(selectedLanguage?.id, () => {
          setSelectedLanguage({
            id: selectedLanguage?.id,
            name: selectedLanguage?.name == 'Arabic' ? 'عربي' : 'English',
          });
          dispatch(setFetchedClient(false));
          dispatch(getUserDetail(user))
          navigate('/funds/available-funds');
        }),
      );
    }
  };

  const handleSubmitPassword = (values) => {
    const apiData = {
      oldPassword: values?.old_password,
      newPassword: values?.new_password,
      confirmPassword: values?.confirm_password,
    };
    dispatch(changePassword(apiData, navigate));
  };

  const handleKycUpdate = (isClientClassification) => {
    if (user?.investorTypeId === 2) {
      const apiData = {
        clientId: user?.clientId,
        callWathq: user?.applicantTypeId?.toString() === '1067' ? true : false,
        languageId: isArabic ? 4 : 3,
      };
      dispatch(
        initiateKyc(apiData, (val) => {
          if (val?.success) {
            navigate(isClientClassification ? '/corporate-form?step=5' : '/corporate-form');
            dispatch(setIsKyc(true));
            dispatch(setClientApplicationId(val?.applicationId));
            dispatch(setClientApplicantId(user?.applicantTypeId));
            dispatch(setKsaCorporate(user?.applicantTypeId?.toString() === '1067'));
            dispatch(setCompanyId(user?.companyTypeId));
            dispatch(setRejectionMsg(user?.wmRejectionComments ?? null));
          } else {
            showToast({
              icon: 'error',
              title: val?.responseMessage,
            });
          }
        }),
      );
    } else {
      window.open(isClientClassification ? process.env.REACT_APP_KYC_UPDATE_CLIENT_CLASSIFICATION : process.env.REACT_APP_KYC_UPDATE, '_blank');
      // dispatch(
      //   createKycApplication(
      //     {
      //       clientId: user?.clientId?.toString(),
      //       languageId: isArabic ? 4 : 3,
      //     },
      //     (val) => {
      //       if (val?.status) {
      //         navigate('/individual-form');
      //         dispatch(setIsKyc(true));
      //         dispatch(setClientApplicationId(Number(val?.message)));
      //         dispatch(setApplicantType(type));
      //       } else {
      //         showToast({
      //           icon: 'error',
      //           title: val?.responseMessage,
      //         });
      //       }
      //     },
      //   ),
      // );
    }
  };

  const clientId = user?.investorTypeId === 2 ? clientDetails?.clientInformation?.commercialRegistrationNumber : clientDetails?.clientInformation?.nationalIdentificationNumber;
  const vatNumber = clientDetails?.clientInformation?.vatNumber

  const handleSwitchAccount = () => {
    const api_data = {
      targetClientId: switchAccountData?.clientId,
      investorTypeId: switchAccountData?.investorTypeId,
      languageId: isArabic ? 4 : 3,
    }
    dispatch(selectAccounts(api_data, (res) => {
      dispatch(getClientData());
      navigate('/funds/available-funds');
    }))
  }
  const handleOpenModel = (items) => {
    setConfirmModal(true);
    setSwitchAccountData(items);
  }

  const handleCloseModel = () => {
    setConfirmModal(false)
  }

  return {
    isArabic,
    navigate,
    TextWeight,
    settingLoading,
    languages,
    passwordLoading,
    selectedLanguage,
    getContentKey,
    onLanguageSelect,
    handleSubmitLanguage,
    handleSubmitPassword,
    clientDetails,
    handleKycUpdate,
    kyc_loading,
    clientId,
    vatNumber,
    user,
    confirmModal,
    setConfirmModal,
    handleOpenModel,
    handleCloseModel,
    handleSwitchAccount,
    direction,
  };
};
